module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'expanded': _vm.expanded, 'collapsed': !_vm.expanded
    },
    attrs: {
      "id": "header"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "mdi mdi-close action-icon",
    on: {
      "click": function($event) {
        _vm.expanded = false
      }
    }
  }), _c('img', {
    attrs: {
      "src": require("./../assets/logo-sig-acre.png")
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "col-12 informacoes-sig"
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_vm._v(_vm._s(_vm.informacoes))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2328522c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 472
// module chunks = 1